module.exports = __webpack_public_path__ + "img/oats.be5030ca.webp";